import { render, staticRenderFns } from "./signOtherList.vue?vue&type=template&id=27108438"
import script from "./signOtherList.vue?vue&type=script&lang=js"
export * from "./signOtherList.vue?vue&type=script&lang=js"
import style0 from "./signOtherList.vue?vue&type=style&index=0&id=27108438&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports